/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyCategoriesResponse } from '../../models/company-categories-response';

export interface GetCompanyCategories$Params {
}

export function getCompanyCategories(http: HttpClient, rootUrl: string, params?: GetCompanyCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCategoriesResponse>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyCategories.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyCategoriesResponse>>;
    })
  );
}

getCompanyCategories.PATH = '/api/company-categories';
